import { TableCell } from "@mui/material";
import { styled } from "@mui/styles";

export const Cell = styled(TableCell)({
    //@ts-ignore
    textAlign: "right !important",
    "&.MuiTableCell-root": {
        fontFamily: "'Yekan !important'",
    }

})

export const PaginationStyle = {
    direction: "ltr",
    borderBottomLeftRadius: "15px",
    borderBottomRightRadius: "15px",
    "& .MuiToolbar-root-MuiTablePagination-toolbar": {
        minHeight: "1rem",
    },
    "& .MuiTablePagination-selectLabel": {
        fontFamily: "'Yekan !important'",
    },
    "& .MuiTablePagination-displayedRows": {
        fontFamily: "'Yekan !important'",
    },
    "& .css-194a1fa-MuiSelect-select-MuiInputBase-input.MuiSelect-select": {
        fontFamily: "'Yekan !important'",
    }
}